<!--
 * @Author: your name
 * @Date: 2020-09-03 15:10:16
 * @LastEditTime: 2022-08-26 11:20:49
 * @LastEditors: zhouhx
 * @Description: In User Settings Edit
 * @FilePath: \1-trunk\src\components\basics\data-modal.vue
-->
// 弹框查看数据组件
<template>
  <div class="comfirm">
    <el-dialog @open='handleOpen' ref='original' :center="true" :close-on-click-modal="false" :before-close="handleDialogClose" :title="title" :append-to-body="true" :visible.sync="dialogState" v-if="dialogState" :width="comfirmWidth">
      <slot name="main"></slot>
      <div class="addPart" :class="{'haveBorder':addBorder}" slot="footer" v-if="btnArr">
        <span class="dialog-footer" v-for="(item,key) in btnArr" :key="key">
          <button @click.prevent="$emit('changeDataDialog',item.backMsg)" :class="item.class">{{item.name}}</button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    btnArr: {
      type: Array
    },
    comfirmWidth: {
      type: String
    },
    comfirmHeight: {
      type: String
    },
    dialogState: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '提示'
    },
    cutImg: {
      type: String
    },
    fileData: {
      type: Array
    },
    resultLocalImg: {
      type: Array
    }
  },
  data () {
    return {
      hhh: 'hhh',
      fileDataShow: {},
      addBorder: Boolean
    };
  },
  created () {},
  methods: {
    shuaige () {
      // console.log('没错是我');
    },
    handleDialogClose () {
      this.$emit('changeDataDialog', 'close');
    },
    // 打开弹框事件
    handleOpen () {
      this.$nextTick(() => {
        var mainHeight =
          this.$refs.original.$el.childNodes[0].childNodes[1].clientHeight;
        if (mainHeight === 600 && this.btnArr.length) {
          this.addBorder = true;
        } else {
          this.addBorder = false;
        }
      });
    }
  },
  watch: {
    cutimg () {}
  },
  computed: {},
  components: {}
};
</script>

<style lang="scss" scoped>
.el-dialog__wrapper ::v-deep .el-dialog__body {
  // max-height: 600px;
  overflow: auto;
  padding: 0;
  border-radius: 6px !important;
}
.el-dialog__wrapper ::v-deep .el-dialog {
  box-shadow: 0 2px 25px 0 #5c5c5c;
  border-radius: 6px !important;
  margin-bottom: 0;
}
.haveBorder {
  box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.1);
}
.el-dialog__wrapper ::v-deep .el-dialog__title {
  font-size: 16px;
  color: $black000;
  letter-spacing: 0.21px;
  text-align: center;
  font-weight: 500;
}
.el-dialog__wrapper ::v-deep .el-dialog__headerbtn {
  right: 20px;
  // left: 20px;
}
.el-dialog__wrapper ::v-deep .el-dialog__footer {
  margin: 0;
  padding: 0;
}
.comfirmBtn {
  width: 100%;
  height: 52px;
  background-image: linear-gradient(90deg, #5c94ff 21%, #477de5 83%);
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 500;
}
.comfirmAndCancel {
  width: 76px;
  border-radius: 4px;
  height: 44px;
  font-size: 16px;
  letter-spacing: 0;
  text-align: center;
  font-weight: 500;
  margin: 10px 10px 15px;
}
.submitBtn {
  background: #536cf5;
  width: 70%;
  display: inline-block;
  line-height: 56px;
  text-align: center;
  color:$white;
}
.cancelBtn {
  background: #1ad26b;
  width: 30%;
  display: inline-block;
  line-height: 56px;
  text-align: center;
  color:$white;
}
.smallComfirm {
  background-image: linear-gradient(90deg, #5c94ff 21%, #477de5 83%);
  color: #ffffff;
}
.smallCancel {
  background-color: #fff;
  color: #478ff8;
  border: 1px solid #478ff8;
}
</style>
